function requireImg(img) {
  return require(`@apgm/assets/images/${img}`);
}
function requireSvg(img) {
  return require(`@apgm/assets/svg/${img}`);
}
export const navbar = [
  {
    text: "ag_nav_about",
    href: "https://careers.shopee.sg/about/",
    target: "_blank",
  },
  {
    text: "ag_nav_whyshopee",
    href: "https://careers.shopee.sg/why-shopee/",
    target: "_blank",
  },
  {
    text: "ag_nav_jobs",
    href: "https://careers.shopee.sg/jobs/",
    target: "_blank",
  },
  {
    text: "ag_nav_students",
    href: "https://careers.shopee.sg/students/",
    target: "_blank",
  },
  {
    text: "ag_nav_tech",
    href: "https://careers.shopee.sg/tech/",
    target: "_blank",
  },
  {
    text: "ag_nav_events",
    href: "https://careers.shopee.sg/recruitment-event/",
    target: "_blank",
  },
];

export const about = {
  title: "ag_about_title_1",
  desc: ["ag_about_desc"],
};

export const storeForU = {
  title: "ag_store_session_title",
  list: [
    {
      img: requireImg("internaship_pragram.jpg"),
      title: "ag_store_mentorship_title",
      desc: "ag_store_mentorship_desc",
    },
    {
      img: requireImg("store_ownership.jpg"),
      title: "ag_store_ownership_title",
      desc: "ag_store_ownership_desc",
    },
    {
      img: requireImg("expand_your_network.jpg"),
      title: "ag_store_enriching_title",
      desc: "ag_store_enriching_desc",
    },
    {
      img: requireImg("store_fasttrack.jpg"),
      title: "ag_store_fasttrack_title",
      desc: "ag_store_fasttrack_desc",
    },
  ],
};

export const teams = {
  title: "ag_teams_session_title",
  topIntroduce: "ag_teams_top_introduction",
  bottomIntroduce: "ag_teams_bottom_introduction",
  list: [
    {
      img: requireImg("teams-dev-commer.png"),
      title: "ag_teams_dev_commer_title",
      desc: "ag_teams_dev_commer_desc",
    },
    {
      img: requireImg("teams-intelligence.png"),
      title: "ag_teams_intelligence_title",
      desc: "ag_teams_intelligence_desc",
    },
    {
      img: requireImg("teams-marketing.png"),
      title: "ag_teams_marketing_title",
      desc: "ag_teams_marketing_desc",
    },
    {
      img: requireImg("teams-operations.png"),
      title: "ag_teams_operations_title",
      desc: "ag_teams_operations_desc",
    },
    {
      img: requireImg("teams-finance.png"),
      title: "ag_teams_financial_products",
      desc: "ag_teams_financial_products_desc",
    },
  ],
};

export const gallery = {
  title: "ag_gallery_session_title",
  list: [
    {
      original: requireImg("gallery-new-4.jpg"),
      description: {
        introduction: "ag_gallery_introduction_new_4",
        info: {
          title: "ag_gallery_info_name_new_4",
          profession: "ag_gallery_info_profession_new_4",
          country: "ag_gallery_info_country_new_4",
        },
      },
    },
    {
      original: requireImg("gallery-new-1.jpg"),
      description: {
        introduction: "ag_gallery_introduction_new_1",
        info: {
          title: "ag_gallery_info_name_new_1",
          profession: "ag_gallery_info_profession_new_1",
          country: "ag_gallery_info_country_new_1",
        },
      },
    },
    {
      original: requireImg("gallery-new-2.jpg"),
      description: {
        introduction: "ag_gallery_introduction_new_2",
        info: {
          title: "ag_gallery_info_name_new_2",
          profession: "ag_gallery_info_profession_new_2",
          country: "ag_gallery_info_country_new_2",
        },
      },
    },
    {
      original: requireImg("gallery-new-3.jpg"),
      description: {
        introduction: "ag_gallery_introduction_new_3",
        info: {
          title: "ag_gallery_info_name_new_3",
          profession: "ag_gallery_info_profession_new_3",
          country: "ag_gallery_info_country_new_3",
        },
      },
    },
  ],
};

export const haveITaskCards = {
  title: "ag_havecard_session_title",
  list: [
    {
      desc: "ag_havecard_list_desc_1",
      icon: requireImg("havecard-1.png"),
    },
    {
      desc: "ag_havecard_list_desc_2",
      icon: requireImg("havecard-2.png"),
    },
    {
      desc: "ag_havecard_list_desc_3",
      icon: requireImg("havecard-3.png"),
    },
    {
      desc: "ag_havecard_list_desc_4",
      icon: requireImg("havecard-4.png"),
    },
  ],
};

export const submission = {
  title: "ag_submission_session_title",
  explain: "ag_submission_session_explain",
  list: [
    {
      title: "ag_submission_list_title_1",
      desc: "ag_submission_list_desc_1",
    },
    {
      title: "ag_submission_list_title_2",
      desc: "ag_submission_list_desc_2",
    },
    {
      title: "ag_submission_list_title_3",
      desc: "ag_submission_list_desc_3",
    },
    {
      title: "ag_submission_list_title_4",
      desc: "ag_submission_list_desc_4",
    },
  ],
};

export const video = {
  playId: "Branding",
  videoKey: "boZ0L-6I95Q",
  videoImg: requireImg("video-bg.jpg"),
};

export const offices = {
  title: "ag_offices_session_title",
  desc: "ag_offices_session_desc",
  list: [
    {
      link: "",
      colorImg: requireSvg("singapore.svg"),
      grayImg: requireSvg("singapore-gray.svg"),
      title: "ag_offices_list_title_1",
      desc: "ag_offices_list_desc_1",
    },
    {
      link: "",
      colorImg: requireSvg("kualaLumpur.svg"),
      grayImg: requireSvg("kualaLumpur-gray.svg"),
      title: "ag_offices_list_title_2",
      desc: "ag_offices_list_desc_2",
    },
    {
      link: "",
      colorImg: requireSvg("jakarta.svg"),
      grayImg: requireSvg("jakarta-gray.svg"),
      title: "ag_offices_list_title_3",
      desc: "ag_offices_list_desc_3",
    },
    {
      link: "",
      colorImg: requireSvg("manila.svg"),
      grayImg: requireSvg("manila-gray.svg"),
      title: "ag_offices_list_title_4",
      desc: "ag_offices_list_desc_4",
    },
    {
      link: "",
      colorImg: requireSvg("taiwan.svg"),
      grayImg: requireSvg("taiwan-gray.svg"),
      title: "ag_offices_list_title_5",
      desc: "ag_offices_list_desc_5",
    },
    {
      link: "",
      colorImg: requireSvg("thailand.svg"),
      grayImg: requireSvg("thailand-gray.svg"),
      title: "ag_offices_list_title_6",
      desc: "ag_offices_list_desc_6",
    },
    {
      link: "",
      colorImg: requireSvg("shenzhen.svg"),
      grayImg: requireSvg("shenzhen-gray.svg"),
      title: "ag_offices_list_title_7",
      desc: "ag_offices_list_desc_7",
    },
    {
      link: "",
      colorImg: requireSvg("vietnam.svg"),
      grayImg: requireSvg("vietnam-gray.svg"),
      title: "ag_offices_list_title_8",
      desc: "ag_offices_list_desc_8",
    },
  ],
};

const faqSession = {
  list: [
    {
      question: "ag_faq_session_list_question_1",
      desc: ["ag_faq_session_list_a_1"],
    },
    {
      question: "ag_faq_session_list_question_3",
      desc: ["ag_faq_session_list_a_3"],
    },
    {
      question: "ag_faq_session_list_question_4",
      desc: ["ag_faq_session_list_a_4"],
    },
    {
      question: "ag_faq_session_list_question_5",
      desc: ["ag_faq_session_list_a_5"],
    },
    {
      question: "ag_faq_session_list_question_6",
      desc: ["ag_faq_session_list_a_6"],
    },
    {
      question: "ag_faq_session_list_question_7",
      desc: ["ag_faq_session_list_a_7"],
    },
    {
      question: "ag_faq_session_list_question_8",
      desc: ["ag_faq_session_list_a_8"],
    },
    {
      question: "ag_faq_session_list_question_9",
      desc: ["ag_faq_session_list_a_9"],
    },
  ],
};

export const faq = {
  title: "ag_faq_session_title",
  applyNow: "ag_faq_apply_now",
  sections: [faqSession],
};

export const footer = {
  follow: "ag_follow_us",
  social: [
    {
      href: "https://www.facebook.com/shopeecareers/",
      name: "facebook",
      icon: require("@apgm/assets/svg/icon-facebook.svg"),
    },
    {
      href: "https://www.instagram.com/LifeatShopee",
      name: "instagram",
      icon: require("@apgm/assets/svg/icon-instagram.svg"),
    },
    {
      href: "https://linkedin.com/company/shopee",
      name: "linkedin",
      icon: require("@apgm/assets/svg/icon-linkedin.svg"),
    },
  ],
  linkGroupDesc: ["ag_footer_career", "", "ag_footer_more"],
  links: [
    [
      {
        text: "ag_footer_home",
        href: "https://careers.shopee.sg/",
        target: "_blank",
      },
      {
        text: "ag_nav_about",
        href: "https://careers.shopee.sg/about/",
        target: "_blank",
      },
      {
        text: "ag_nav_events",
        href: "https://careers.shopee.sg/recruitment-event/",
        target: "_blank",
      },
      {
        text: "ag_footer_life_at_shopee",
        href: "https://careers.shopee.sg/why-shopee/",
        target: "_blank",
      },
    ],
    [
      {
        text: "ag_nav_jobs",
        href: "https://careers.shopee.sg/jobs/",
        target: "_blank",
      },
      {
        text: "ag_nav_students",
        href: "https://careers.shopee.sg/students/",
        target: "_blank",
      },
      {
        text: "ag_nav_tech",
        href: "https://careers.shopee.sg/tech/",
        target: "_blank",
      },
    ],
    [
      {
        text: "ag_footer_sea_group",
        href: "https://www.seagroup.com/home",
        target: "_blank",
      },
      {
        text: "ag_careers",
        href: "https://careers.shopee.sg/",
        target: "_blank",
      },
      {
        text: "ag_footer_sea_money",
        href: "https://www.monee.com/",
        target: "_blank",
      },
    ],
  ],
  tc: `https://careers.shopee.sg/terms-of-service`,
  privacyPolicy: "https://careers.shopee.sg/privacy-policy",
  copyright:
    "Copyright © Shopee Limited. Trademarks belong to their respective owners. All rights reserved.",
  cookiePreference:
    process.env.REACT_APP_COUNTRY === "br"
      ? "https://careers.shopee.com.br/set-cookie"
      : "",
};
